<!-- Desktop HTML -->
<div *ngIf='screenWidth > 1230'>
  <!-- <div class="visible-lg"> -->
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-lg-history">
      <div class="bmw-lg-history-title">
        Recently Viewed
      </div>
      <div class="bmw-lg-history-list">
        <div *ngFor='let video of videoList;let i=index' class="row bmw-no-gutter bmw-lg-history-video">
          <div class="col-lg-1 bmw-align-text-right" style="font-size: 20px; line-height: 2.7">
            {{i+1}}
          </div>
          <div class="col-lg-2 bmw-no-gutter">
            <div class="bmw-lg-video-home-thumbnail" [routerLink]='["/playback"]'
              [queryParams]='{channel: video.channel.channelNumber, video: video.id, vimeoID: video.videoFileName, watchlist: false}'>
              <img src="{{videoThumbnail}}" title={{video.videoTitle}} />
              <!-- <div class="bmw-video-home-overlay-text bmw-lg-video-home-overlay-text"></div> -->
            </div>
          </div>
          <div class="col-lg-8">
            <!-- <div class="row bmw-no-gutter" [innerHTML]='video.videoDisplayNumber'></div> -->
            <div class="row bmw-no-gutter" [innerHTML]='video.videoTitle'></div>
            <div class="row bmw-no-gutter" style="font-size:12px;color:#777777;margin-top:5px">
              <div style="float: left" [innerHTML]='video.releaseDate | date: dateFormat | highlightSearch: searchKey'>
              </div>
              <div style="float: left; margin-left:10px">{{video.views}} views</div>
            </div>
          </div>
          <div class="col-lg-1 bmw-no-gutter bmw-align-text-right">
            <div class="dropdown dropdown-pull-right btn-group">
              <i class="material-icons dp48 pointer" data-toggle="dropdown">more_vert</i>
              <ul class="dropdown-menu">
                <li class="row bmw-no-gutter pointer"
                  (click)='addVideoToWatchlist(video?.id, video?.videoDisplayNumber)'>
                  <div class="col-lg-2 bmw-no-gutter">
                    <i class="material-icons dp48" style="font-size:20px">remove_red_eye</i>
                  </div>
                  <div class="col-lg-9 bmw-no-gutter">
                    Add to watchlist
                  </div>
                </li>
                <li class="row bmw-no-gutter pointer" data-toggle="modal" data-target="#shareContent"
                  (click)='shareContent(video?.id, "video", video?.channel.channelNumber, video?.videoDisplayNumber)'>
                  <div class="col-lg-2 bmw-no-gutter">
                    <i class="material-icons dp48" style="font-size:20px">share</i>
                  </div>
                  <div class="col-lg-9 bmw-no-gutter">
                    Share
                  </div>
                </li>
                <li class="divider"></li>
                <li class="row bmw-no-gutter">
                  <div class="col-lg-2 bmw-no-gutter">
                    <i class="material-icons" style="font-size:20px">close</i>
                  </div>
                  <div class="col-lg-9 bmw-no-gutter">
                    Cancel
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- </div> -->
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" #modalCloseButton id="shareContent" role="dialog">
      <div class="modal-dialog bmw-share-modal">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:#000000">&times;</button>
            <h4 class="modal-title">Share Content</h4>
          </div>
          <div class="modal-body">
            <app-share-content [shareContent]='shareContentObject'></app-share-content>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<!-- Ipad HTML -->
<div *ngIf='screenWidth >= 991 && screenWidth <= 1230'>
  <!-- <div class="visible-md"> -->
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-md-history">
      <div class="bmw-lg-history-title md">
        Recently Viewed
      </div>
      <div class="bmw-lg-history-list">
        <div *ngFor='let video of videoList;let i=index' class="row bmw-no-gutter bmw-lg-history-video">
          <div class="col-md-1 bmw-align-text-right" style="font-size: 17px; line-height: 3">
            {{i+1}}
          </div>
          <div class="col-md-2 bmw-no-gutter">
            <div class="bmw-lg-video-home-thumbnail" [routerLink]='["/playback"]'
              [queryParams]='{channel: video.channel.channelNumber, video: video.id, vimeoID: video.videoFileName, watchlist: false}'>
              <img src="{{videoThumbnail}}" title={{video.videoTitle}} />
              <!-- <div class="bmw-video-home-overlay-text bmw-md-video-home-overlay-text"></div> -->
            </div>
          </div>
          <div class="col-md-8">
            <div class="row bmw-no-gutter" [innerHTML]='video.videoDisplayNumber'></div>
            <div class="row bmw-no-gutter" [innerHTML]='video.videoTitle'></div>
            <div class="row bmw-no-gutter" style="font-size:12px;color:#777777;margin-top:5px">
              <div style="float: left" [innerHTML]='video.releaseDate | date: dateFormat | highlightSearch: searchKey'>
              </div>
              <div style="float: left; margin-left:10px">{{video.views}} views</div>
            </div>
          </div>
          <div class="col-md-1 bmw-no-gutter bmw-align-text-right">
            <div class="dropdown dropdown-pull-right btn-group">
              <i class="material-icons dp48 pointer" data-toggle="dropdown">more_vert</i>
              <ul class="dropdown-menu">
                <li class="row bmw-no-gutter pointer"
                  (click)='addVideoToWatchlist(video?.id, video?.videoDisplayNumber)'>
                  <div class="col-md-2 bmw-no-gutter">
                    <i class="material-icons dp48" style="font-size:20px">remove_red_eye</i>
                  </div>
                  <div class="col-md-9 bmw-no-gutter">
                    Add to watchlist
                  </div>
                </li>
                <li class="row bmw-no-gutter pointer" data-toggle="modal" data-target="#shareContent"
                  (click)='shareContent(video?.id, "video", video?.channel.channelNumber, video?.videoDisplayNumber)'>
                  <div class="col-md-2 bmw-no-gutter">
                    <i class="material-icons dp48" style="font-size:20px">share</i>
                  </div>
                  <div class="col-md-9 bmw-no-gutter">
                    Share
                  </div>
                </li>
                <li class="divider"></li>
                <li class="row bmw-no-gutter">
                  <div class="col-md-2 bmw-no-gutter">
                    <i class="material-icons" style="font-size:20px">close</i>
                  </div>
                  <div class="col-md-9 bmw-no-gutter">
                    Cancel
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" #modalCloseButton id="shareContent" role="dialog">
      <div class="modal-dialog bmw-md-share-modal">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:#000000">&times;</button>
            <h4 class="modal-title">Share Content</h4>
          </div>
          <div class="modal-body">
            <app-share-content [shareContent]='shareContentObject'></app-share-content>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<!-- Tablet HTML -->
<div *ngIf='screenWidth >= 767 && screenWidth <= 991'>
  <!-- <div class="visible-sm"> -->
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-sm-history">
      <div class="bmw-sm-history-title">
        Recently Viewed
      </div>
      <div class="bmw-lg-history-list">
        <div *ngFor='let video of videoList;let i=index' class="row bmw-no-gutter bmw-lg-history-video">
          <div class="col-sm-1" style="font-size: 20px; line-height: 2.7">
            {{i+1}}
          </div>
          <div class="col-sm-2 bmw-no-gutter" style="margin-left: -35px">
            <div class="bmw-lg-video-home-thumbnail" [routerLink]='["/playback"]'
              [queryParams]='{channel: video.channel.channelNumber, video: video.id, vimeoID: video.videoFileName, watchlist: false}'>
              <img src="{{videoThumbnail}}" title={{video.videoTitle}} />
              <!-- <div class="bmw-video-home-overlay-text bmw-sm-video-home-overlay-text"></div> -->
            </div>
          </div>
          <div class="col-sm-8 bmw-no-gutter">
            <div class="row bmw-no-gutter" [innerHTML]='video.videoDisplayNumber'></div>
            <div class="row bmw-no-gutter" [innerHTML]='video.videoTitle'></div>
            <div class="row bmw-no-gutter" style="font-size:12px;color:#777777;margin-top:5px">
              <div style="float: left" [innerHTML]='video.releaseDate | date: dateFormat | highlightSearch: searchKey'>
              </div>
              <div style="float: left; margin-left:10px">{{video.views}} views</div>
            </div>
          </div>
          <div class="col-sm-1 bmw-no-gutter bmw-align-text-right">
            <div class="dropdown dropdown-pull-right btn-group">
              <i class="material-icons dp48 pointer" data-toggle="dropdown">more_vert</i>
              <ul class="dropdown-menu">
                <li class="row bmw-no-gutter pointer"
                  (click)='addVideoToWatchlist(video?.id, video?.videoDisplayNumber)'>
                  <div class="col-sm-2 bmw-no-gutter">
                    <i class="material-icons dp48" style="font-size:20px">remove_red_eye</i>
                  </div>
                  <div class="col-sm-9 bmw-no-gutter">
                    Add to watchlist
                  </div>
                </li>
                <li class="row bmw-no-gutter pointer" data-toggle="modal" data-target="#shareContent"
                  (click)='shareContent(video?.id, "video", video?.channel.channelNumber, video?.videoDisplayNumber)'>
                  <div class="col-sm-2 bmw-no-gutter">
                    <i class="material-icons dp48" style="font-size:20px">share</i>
                  </div>
                  <div class="col-sm-9 bmw-no-gutter">
                    Share
                  </div>
                </li>
                <li class="divider"></li>
                <li class="row bmw-no-gutter">
                  <div class="col-sm-2 bmw-no-gutter">
                    <i class="material-icons" style="font-size:20px">close</i>
                  </div>
                  <div class="col-sm-9 bmw-no-gutter">
                    Cancel
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" #modalCloseButton id="shareContent" role="dialog">
      <div class="modal-dialog bmw-sm-share-modal">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:#000000">&times;</button>
            <h4 class="modal-title">Share Content</h4>
          </div>
          <div class="modal-body">
            <app-share-content [shareContent]='shareContentObject'></app-share-content>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<!-- Mobile HTML -->
<div *ngIf='screenWidth > 319 && screenWidth < 767'>
  <!-- <div class="visible-xs"> -->
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-xs-history">
      <div class="bmw-xs-history-list">
        <div *ngFor='let video of videoList;let i=index' class="row bmw-no-gutter bmw-xs-history-video">
          <div class="col-xs-1 bmw-no-gutter" style="font-size: 14px; line-height: 6; padding-left: 7px">
            {{i+1}}
          </div>
          <div class="col-xs-5 bmw-no-gutter">
            <div class="bmw-xs-video-home-thumbnail" [routerLink]='["/playback"]'
              [queryParams]='{channel: video.channel.channelNumber, video: video.id, vimeoID: video.videoFileName, watchlist: false}'>
              <img src="{{videoThumbnail}}" title={{video.videoTitle}} />
              <!-- <div class="bmw-video-home-overlay-text bmw-xs-video-home-overlay-text"></div> -->
            </div>
          </div>
          <div class="col-xs-5 bmw-no-gutter" style="padding-left: 4px">
            <div class="row bmw-no-gutter" [innerHTML]='video.videoDisplayNumber'></div>
            <div class="row bmw-no-gutter"
              [innerHTML]='video.videoTitle.length > 19 ? video.videoTitle.substr(0,20)+"..." : video.videoTitle'></div>
            <div class="row bmw-no-gutter" style="font-size:12px;color:#777777;margin-top:5px">
              <div style="float: left" [innerHTML]='video.releaseDate | date: dateFormat | highlightSearch: searchKey'>
              </div>
              <div style="float: left; margin-left:10px">{{video.views}} views</div>
            </div>
          </div>
          <div class="col-xs-1 bmw-no-gutter bmw-align-text-right">
            <div class="dropdown dropdown-pull-right btn-group">
              <i class="material-icons dp48 pointer" data-toggle="dropdown">more_vert</i>
              <ul class="dropdown-menu">
                <li class="row bmw-no-gutter pointer"
                  (click)='addVideoToWatchlist(video?.id, video?.videoDisplayNumber)'>
                  <div class="col-xs-2 bmw-no-gutter">
                    <i class="material-icons dp48" style="font-size:20px">remove_red_eye</i>
                  </div>
                  <div class="col-xs-9 bmw-no-gutter">
                    Add to watchlist
                  </div>
                </li>
                <li class="row bmw-no-gutter pointer" data-toggle="modal" data-target="#shareContent"
                  (click)='shareContent(video?.id, "video", video?.channel.channelNumber, video?.videoDisplayNumber)'>
                  <div class="col-xs-2 bmw-no-gutter">
                    <i class="material-icons dp48" style="font-size:20px">share</i>
                  </div>
                  <div class="col-xs-9 bmw-no-gutter">
                    Share
                  </div>
                </li>
                <li class="divider"></li>
                <li class="row bmw-no-gutter">
                  <div class="col-xs-2 bmw-no-gutter">
                    <i class="material-icons" style="font-size:20px">close</i>
                  </div>
                  <div class="col-xs-9 bmw-no-gutter">
                    Cancel
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" #modalCloseButton id="shareContent" role="dialog">
      <div class="modal-dialog bmw-xs-share-modal">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:#000000">&times;</button>
            <h4 class="modal-title">Share Content</h4>
          </div>
          <div class="modal-body">
            <app-share-content [shareContent]='shareContentObject'></app-share-content>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
          </div>
        </div>

      </div>
    </div>
  </div>
</div>